import CustomerFileTable from './CustomerFileTable';
import SettingsDialogPage from '../../../components/SettingsDialogPage';

const SignSettings = () => (
	<SettingsDialogPage title="Signature">
		<CustomerFileTable />
	</SettingsDialogPage>
);

export default SignSettings;
